import { useParams } from "next/navigation";

import { useTranslation } from "./useTranslation";

/**
 * Translation hook for pages under a `[lang]` route segment.
 * The route param wins; the locale store remains the fallback when the
 * component renders outside a `[lang]` tree (useTranslation handles that).
 */
export function usePageTranslation() {
  const params = useParams();
  const lang = typeof params?.lang === "string" ? params.lang : undefined;
  return useTranslation(lang);
}
